import React from "react";
import Feed from "./Feed/Feed";

const Cours = () => {
  return (
    <div className="container px-6 md:px-0 mx-auto py-44 text-primary1">
      <Feed />
    </div>
  );
};

export default Cours;
